module.exports = __webpack_public_path__ + "img/rock-big-10.c58e212b.png";